module.exports = __webpack_public_path__ + "img/g5.f40c1670.png";